var map = {
	"./az.json": [
		6640,
		618
	],
	"./cs.json": [
		5634,
		1375
	],
	"./de.json": [
		5299,
		1326
	],
	"./en.json": [
		6443,
		4130
	],
	"./es.json": [
		5932,
		8561
	],
	"./it.json": [
		8409,
		9776
	],
	"./kk.json": [
		514,
		5791
	],
	"./lv.json": [
		7962,
		7387
	],
	"./pl.json": [
		2284,
		3573
	],
	"./pt.json": [
		596,
		637
	],
	"./ru.json": [
		1357,
		9808
	],
	"./tr.json": [
		6110,
		7647
	],
	"./uk.json": [
		2308,
		6329
	],
	"./uz.json": [
		9047,
		8422
	],
	"./vi.json": [
		7813,
		5808
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8011;
module.exports = webpackAsyncContext;